import makeApiRequest from '../api/makeApiCall';
import { Config } from '../latest/src/constants/AppServerConfig';

const QUESTIONNAIRE_ENDPOINT = `${Config.questionnaireService}questionnaire`;
const QUESTIONNAIRE_SCHEDULING_ENDPOINT = `${Config.questionnaireService}`;
const QUESTIONNAIRE_RESPONSE_ENDPOINT = `${Config.questionnaireResponses}`;
type UserType = 'client' | 'therapist';

type QuestionType = 'intake' | 'checkin' | 'checkout';

/**
 * Get questionnaire
 * @param {String} userType - UserType
 * @param {String} questionType - QuestionType
 * @param {String} clusterID - clusterID
 * @param {String} therapySessionId - therapySessionId
 * @returns {Promise}
 */
export async function getQuestionnaire(userType: UserType, questionType: QuestionType, clusterID: String, therapySessionId: String) {
    if (userType === 'client' && questionType === 'checkin') {
        return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}/?cluster_id=${clusterID}&questionnaire_type=CLIENT_CHECKIN&therapy_session_id=${therapySessionId}`, 'GET');
    } else if (userType === 'client' && questionType === 'checkout') {
        return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}/?cluster_id=${clusterID}&questionnaire_type=CLIENT_CHECKOUT&therapy_session_id=${therapySessionId}`, 'GET');
    } else {
        return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}/${userType?.toLowerCase()}/${questionType.toLowerCase()}`, 'GET');
    }
}

export const completeQuestionnaire = async (data:Object) => {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/submit`, 'POST', data);
};

export const addQuestionnaire = async (data: Object) => {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/?therapy_session_id=${data.therapySessionId}`, 'POST', data);
};

export const updateQuestionnaire = async (data:Object) => {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion`, 'PUT', data);
};


// New Teletherapy Endpoint Client Check In response post
export const postClientcheckInResponse = async (data: Object) => {
    return await makeApiRequest(`${QUESTIONNAIRE_RESPONSE_ENDPOINT}?clientid=${data.clientid}&type=client-checkin&therapy_session_id=${data.therapySessionId}`, 'POST', data);
};

/**
 * Submit completed therapist checkin questionnaire
 * @param {Object} data - { questionnaireType, data }
 * @param {String} type - 'checkin' | 'checkout'
 * @returns {Promise}
 */
export async function completeTherapistQuestionnaire(data: Object, type: 'checkin' | 'checkout') {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/therapist/${type}`, 'POST', data);
}

export async function completeTherapistQuestionnaireCheckout(data: Object) {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/therapist/checkout`, 'POST', data);
}

export async function getClientQuestionnaireResponse(checkinId: string) {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/client/checkin/${checkinId}`);
}

export const getQuestionResult = async (userType:UserType, data:Object) => {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/${userType}/completions/list`, 'POST', data);
};

// New Endpoint to GET client responses
// ========================================

export const getClientCheckInResponse = async (data: Object) => {
    return await makeApiRequest(`${QUESTIONNAIRE_ENDPOINT}-completion/client/checkin/${data.checkinQuestionnaireId}?cluster_id=${data.clusterId}&therapy_session_id=${data.id}&questionnaire_type=CLIENT_CHECKIN`);
};

// self-schduling

export const SelfSchedulingCall = async (data : Object) => {

    return await makeApiRequest(`${QUESTIONNAIRE_SCHEDULING_ENDPOINT}questionnaire-completion-sessions/_self-matching-intake`, 'POST', data);
};
